/**
 *
 * Asynchronously loads the component for SendSmsPopup
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
